/* istanbul ignore file */
import eventManager from './event-manager-factory';

export default eventManager;
